import Icon from '../components/Icon.vue'

Icon.register({
  'quote-right': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 32c26.5 0 48 21.5 48 48v240c0 88.4-71.6 160-160 160h-8c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24h8c35.3 0 64-28.7 64-64v-64h-80c-26.5 0-48-21.5-48-48v-128c0-26.5 21.5-48 48-48h128zM176 32c26.5 0 48 21.5 48 48v240c0 88.4-71.6 160-160 160h-8c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24h8c35.3 0 64-28.7 64-64v-64h-80c-26.5 0-48-21.5-48-48v-128c0-26.5 21.5-48 48-48h128z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/quote-right.js
// module id = 1673
// module chunks = 0